import styled from "styled-components";

export const Container = styled.button`
  padding: 1rem 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: transparent;
  width: 100%;
  border: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
`;

export const DescriptionAnimal = styled.div`
  display: flex;
  align-items: center;

  p {
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.gray};
    line-height: 16px;
    text-align: left;
    margin-bottom: 0;

    span {
      color: ${({ theme }) => theme.colors.black};
      font-weight: 600;
    }
  }

  img {
    margin-right: 0.5rem;
    width: 40px;
    height: 40px;
    border-radius: 20px;
  }
`;
